import React from 'react';
import { Box, Heading, Link, Text } from '@chakra-ui/react';

export default function ShowKeyAndValue({ keyName, value, linkText, helperText }) {
  const isLink = /^(http|https):\/\/[^\s/$.?#].[^\s]*$/.test(value);

  return (
    <Box p={3} borderRadius='8px' bg='gray.100'>
      <Heading as='h2' size='md'>
        {keyName}
      </Heading>
      {isLink ? (
        <Link
          href={value}
          color='blue.500'
          overflow='hidden'
          textOverflow='ellipsis'
          display='block'
          whiteSpace='nowrap'
          isExternal
        >
          {linkText || value}
        </Link>
      ) : (
        <Text color='gray'>{value}</Text>
      )}
      {helperText && (
        <Text fontSize='xs' color='gray.500' mt={1} wordBreak='break-all'>
          {helperText}
        </Text>
      )}
    </Box>
  );
}
